
export enum PaymentType {
  CREDIT_CARD = 'credit card payment',
  CARGO_SPRINT = 'Cargo Sprint',
  PAY_CARGO = 'Pay Cargo',
  ALTERNATIVE_PAYMENT = 'alternative payment',
  INVOICE_PAYMENT = 'invoice payment',
  ACH = 'ach payment',
  CHEQUE = 'Cheque',
  CASH = 'Cash',
  NOT_PAID = 'not_paid',
  OVER_PAID = 'overpayment',
  UNDER_PAID = 'underpayment',
  PARTIALLY_PAID = 'partially_paid',
  CREDIT_ACCOUNT = 'credit account',
  E_WALLET_PAYMENT = 'e wallet payment'
};
